// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FLfG","type":"styles_type__2KXGv","choices":"styles_choices__1aN6b"};